module.exports = __webpack_public_path__ + "img/page_vocabulary_list.8ac0a534.jpg";